module.exports = __webpack_public_path__ + "static/media/websiteanimated.16e31b04.gif";